import { AI_PAIN } from "../content";
import { AiSectionHead } from "./AiSection";

/** 为什么 AI 需要专门的数据安全：四张痛点卡。对应设计稿第 2 节。 */
export default function AiWhy() {
  return (
    <section aria-labelledby="ai-why-h" className="py-14 lg:py-20">
      <AiSectionHead eyebrow={AI_PAIN.eyebrow} title={AI_PAIN.title} sub={AI_PAIN.sub} />
      <div className="grid gap-5 md:grid-cols-2">
        {AI_PAIN.items.map((p) => (
          <div
            key={p.title}
            className="grid grid-cols-[42px_minmax(0,1fr)] gap-5 p-6 rounded-2xl bg-white border border-gray-200 border-l-4 border-l-[#b45309] transition-transform duration-200 hover:-translate-y-1"
          >
            <span className="w-[42px] h-[42px] rounded-[10px] grid place-items-center text-lg bg-[#fff7ed] text-[#b45309]">
              <i className={p.icon}></i>
            </span>
            <div>
              <h4 className="text-[15px] font-bold text-[#0d1f3c] mb-2">{p.title}</h4>
              <p className="m-0 text-sm text-[#475569] leading-relaxed">{p.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
